import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CaeImportErrorCollector } from '../cae-import-error-collector';
import { TranslateModule } from '@ngx-translate/core';
import { TableColumnDirective, TableComponent } from '@shared/table/table.component';

@Component({
  selector: 'app-cae-result',
  imports: [
    TranslateModule,
    TableComponent,
    TableColumnDirective,
  ],
  templateUrl: './cae-result.component.html',
  styleUrl: './cae-result.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CaeResultComponent {
  public caeImportErrorCollectors = input.required<CaeImportErrorCollector[]>();
  public caeImportErrors = computed(() => this.caeImportErrorCollectors().flatMap((collector) => collector.errors));

  public toTranslateParams(messageParams: string[]): Record<string, string> {
    const params: Record<string, string> = {};
    for (let i = 0; i < messageParams.length; i++) {
      params[`${ i }`] = messageParams[i];
    }
    return params;
  }
}
